(function () {
  'use strict';

  var configElement = document.getElementById('AmourProductReviewSchemaConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  if (!config.shop || !config.productId || !config.productSchemaId) return;

  var themeProductSchema = document.querySelector(
    'script[type="application/ld+json"][data-creator-name="AmourDiamant theme"]'
  );

  if (themeProductSchema) {
    try {
      var themeProductData = JSON.parse(themeProductSchema.textContent);
      var existingRating = themeProductData.aggregateRating;
      var existingCount = Number(existingRating && existingRating.ratingCount);
      var existingValue = Number(existingRating && existingRating.ratingValue);

      if (
        Number.isInteger(existingCount) &&
        existingCount > 0 &&
        Number.isFinite(existingValue) &&
        existingValue >= 1 &&
        existingValue <= 5
      ) {
        return;
      }
    } catch (error) {
      return;
    }
  }

  var formData = new FormData();
  formData.append('shop', config.shop);
  formData.append('pageSize', '1');
  formData.append('page', '1');
  formData.append('allEnapReview', '0');
  formData.append('productId', String(config.productId));

  fetch('https://reviews.enormapps.com/product-reviews/api/reviews', {
    method: 'POST',
    body: formData
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Review request failed');
      return response.json();
    })
    .then(function (data) {
      var ratingCount = Number(data.totalProductReview);
      var ratingValue = Number(data.avgRating);

      if (
        !Number.isInteger(ratingCount) ||
        ratingCount <= 0 ||
        !Number.isFinite(ratingValue) ||
        ratingValue < 1 ||
        ratingValue > 5
      ) {
        return;
      }

      ratingValue = Math.round(ratingValue * 10) / 10;

      if (!themeProductSchema || !themeProductData) return;

      themeProductData.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: ratingValue,
        ratingCount: ratingCount,
        bestRating: 5,
        worstRating: 1
      };
      themeProductSchema.textContent = JSON.stringify(themeProductData);
    })
    .catch(function () {
      // Review rich results are optional. A failed app request must never emit
      // incomplete or invalid rating markup.
    });
})();
